class MyPageFaqItem extends HTMLElement {
  constructor() {
    super();
    this.btn = this.querySelector('.my-subtitle');
    this.desc = this.querySelector('.my-desc');
  }
  connectedCallback() {
    this.computeDomHeight(this.desc);
    this.btn.addEventListener('click', this.clickHandle.bind(this));
    window.addEventListener('resize', debounce(this.resizeHandle.bind(this)));
  }
  clickHandle () {
    this.classList.toggle('active');
  }
  resizeHandle() {
    this.computeDomHeight(this.desc);
  }
  computeDomHeight(dom) {
    dom.style.height = 'auto';
    const height = getComputedStyle(dom).height;
    dom.style.removeProperty('height');
    dom.offsetHeight;
    dom.style.setProperty('--h', `${height}`);
  }
}
customElements.define('my-page-faq-item', MyPageFaqItem);